import { createSlice } from '@reduxjs/toolkit'

import {
  markAsOtpAttempt,
  markAsOtpLimitReached,
  resetOtpLimitReached,
  unmarkAsOtpLimitReached,
} from './shared/otp'

export const initialState = {
  key: '',
  email: '',
  phoneNumber: '',
  username: '',
  pageReferer: {
    url: '',
    btnLabel: '',
  },
  attempt: 0,
  lastResendAttemptTime: 0,
  rateLimitLockedTime: 0,
  isRateLimitReached: false,
  isInputRateLimitReached: false,
}

const forgotPinSlice = createSlice({
  name: 'forgotPin',
  initialState,
  reducers: {
    setPageReferer: (state, action) => {
      const fromProfile = {
        url: '/profile',
        btnLabel: 'Back to Profile',
      }

      const page = {
        '/profile/change/pin': fromProfile,
        '/profile/change/phone': fromProfile,
        '/profile/change/email': fromProfile,
        '/profile/change/bank-account': fromProfile,
        '/profile/add/bank-account': fromProfile,
        '/profile/add/bank-account?source=select_withdraw_method': {
          url: '/rewards/select-withdraw-method',
          btnLabel: 'Back to Withdraw',
        },
        '/rewards/proceed': {
          url: '/rewards/select-withdraw-method',
          btnLabel: 'Back to Withdraw',
        },
        '/profile/delete-account/proceed': fromProfile,
        '/account-deletion/cancel': {
          url: '/account-deletion/cancel',
          btnLabel: 'Cancel Account Deletion',
        },
      }

      const { pathname, query } = action.payload
      const queryString = new URLSearchParams(query).toString()
      const key = queryString ? `${pathname}?${queryString}` : pathname

      state.pageReferer = page?.[key as keyof typeof page] as typeof initialState.pageReferer
    },
    setForgotKey: (state, action) => {
      state.key = action.payload
    },
    setForgotPinUsername: (
      state,
      action: { payload: { email?: string; phoneNumber?: string } },
    ) => {
      state.email = action.payload.email || ''
      state.phoneNumber = action.payload.phoneNumber || ''
    },
    resetForgotPinState: () => {
      return initialState
    },
    setForgotUsername: (state, action) => {
      state.username = action.payload
    },
    markAsForgotPinAttempt: markAsOtpAttempt,
    resetForgotPinLimitReached: resetOtpLimitReached,
    markAsForgotPinLimitReached: (
      state,
      action: { type: string; payload: { remainingTime: number } },
    ) => markAsOtpLimitReached(state, action.payload),
    markAsForgotInputLimitReached: (
      state,
      action: { type: string; payload: { remainingTime: number } },
    ) => {
      markAsOtpLimitReached(state, action.payload)

      state.isRateLimitReached = false
      state.isInputRateLimitReached = true
    },
    unmarkAsForgotPinLimitReached: unmarkAsOtpLimitReached,
  },
})

export const {
  setForgotKey,
  setForgotPinUsername,
  resetForgotPinState,
  setPageReferer,
  markAsForgotPinAttempt,
  resetForgotPinLimitReached,
  markAsForgotPinLimitReached,
  unmarkAsForgotPinLimitReached,
  setForgotUsername,
  markAsForgotInputLimitReached,
} = forgotPinSlice.actions

export default forgotPinSlice.reducer
